import {
  Collapse,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useMemo, useState } from "react";
import { EOptionType } from "../../../../../../../interfaces/enums";
import { IUso } from "../../../../../../../interfaces/lotto/attributes/models";
import { isFilterAndValueSelected } from "../../../../../../../lib/filters";
import { useAppSelector } from "../../../../../../../store/hooks";
import { IFilterProps } from "../../interfaces";

function UsiFilter({ filters, setFilters }: IFilterProps) {
  const [open, setOpen] = useState<boolean>(false);

  const usoList = useAppSelector((state) => state.lotto_uso.list);
  const usoItems = useAppSelector((state) => state.lotto_uso.items);

  const list: IUso[] = useMemo(
    () => (!!usoList && !!usoItems ? usoList.map((id) => usoItems[id]) : []),
    [usoList, usoItems]
  );

  const toggle = () => {
    setOpen(!open);
  };

  const toggleSelected = (item: IUso) => {
    if (isFilterAndValueSelected(filters, EOptionType.uso, item.id)) {
      setFilters(
        filters.filter(
          (opt) =>
            !(opt.type === EOptionType.uso && opt.numericValue === item.id)
        )
      );
    } else {
      setFilters([
        ...filters,
        {
          type: EOptionType.uso,
          numericValue: item.id,
          stringValue: item.nome,
        },
      ]);
    }
  };

  return (
    <>
      <ListItemButton onClick={toggle}>
        <ListItemIcon>
          <Icon className="fa-light fa-ruler" sx={{ overflow: "visible" }} />
        </ListItemIcon>
        <ListItemText primary="Usi" />
        {open ? (
          <Icon
            className="fa-light fa-angle-up"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        ) : (
          <Icon
            className="fa-light fa-angle-down"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List dense={true}>
          {list.map((item) => (
            <ListItemButton
              key={item.id}
              sx={{ display: "flex", pl: 5, pr: 1 }}
              onClick={() => toggleSelected(item)}
              selected={isFilterAndValueSelected(
                filters,
                EOptionType.uso,
                item.id
              )}
            >
              <ListItemText sx={{ flex: 1 }} primary={item.nome} />
              <ListItemIcon sx={{ minWidth: 0 }}>
                {isFilterAndValueSelected(
                  filters,
                  EOptionType.uso,
                  item.id
                ) && (
                  <Icon
                    className="fa-light fa-check"
                    sx={{ overflow: "visible" }}
                  />
                )}
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
}

export default UsiFilter;
